export default __webpack_public_path__ + "static/media/logo.f6b6ad65.jpg";